/*
 * @Descripttion:
 * @version:
 * @Author: dengyao
 * @Date: 2023-11-30 09:33:00
 * @LastEditors: hongye
 * @LastEditTime: 2024-10-23 14:56:11
 */
import { defineStore } from 'pinia'
import { LoginRes } from '@/service/model'
import { ajaxAuthService,commonService } from '@/service/api/index'
import { isSuccess } from '@/utils'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: '',
    userInfo: {} as LoginRes,
    userLevel: '',
    isLoggedIn: false,
    menuList: [
      {
        name: '首页',
        icon: 'index',
        id: 1,
        path: '/dataDashboard'
      },
      {
        name: '数据中心',
        icon: 'dataCenter',
        id: 2,
        childs: [
          {
            name: '员工派件列表',
            id: 21,
            parentId: 2,
            path: '/staffDispatchList'
          },
          {
            name: '签收图片合格率报表',
            id: 22,
            parentId: 2,
            path: '/picturePassRate'
          }
        ]
      },
      {
        name: '快件跟踪',
        icon: 'expressTracking',
        id: 3,
        path: '/expressTracking'
      },
      {
        name: '订单录入',
        icon: 'orderEntry',
        id: 4,
        path: '/orderEntry'
      },
      {
        name: '订单列表',
        icon: 'orderList',
        id: 5,
        path: '/orderList'
      },
      {
        name: '寄件入库',
        icon: 'sendWarehouse',
        id: 6,
        path: '/sendWarehouse'
      },
      {
        name: '客户管理',
        icon: 'clientManagement',
        id: 7,
        path: '/clientManagement'
      },
      {
        name: '交接列表',
        icon: 'handoverList',
        id: 8,
        path: '/handoverList'
      },
      {
        name: '派件列表',
        icon: 'handoverList',
        id: 9,
        path: '/dispatchList'
      },
      {
        name: '设置',
        icon: 'setting',
        id: 10,
        childs: [
          {
            name: '修改密码',
            id: 101,
            parentId: 10,
            path: '/updatePwd'
          },
          {
            name: '打印设置',
            id: 102,
            parentId: 10,
            path: '/printSetting'
          },
          {
            name: '寄件设置',
            id: 103,
            parentId: 10,
            path: '/sendSetting'
          }
        ]
      }
    ],
    orderInfo: {} as any,
    quickPrintOrderInfo: {} as any,
    cityList: [] as any,
    twoLevelCityList: [] as any,
    addressVersion: ''
  }),
  getters: {
    getMenusList: (state) => state.menuList,
    getUserLevel: (state) => state.userLevel,
    getOrderInfo: (state) => state.orderInfo,
    getQuickPrintOrderInfo: (state) => state.quickPrintOrderInfo,
    getCityList: (state) => state.cityList,
    getTwoLevelCityList: (state) => state.twoLevelCityList,
    getAddressVersion: (state) => state.addressVersion
  },
  actions: {
    //登录
    login(params: any) {
      return new Promise((resolve, reject) => {
        ajaxAuthService
          .login(params)
          .then((res) => {
            if (res.code === 1) {
              this.userInfo = res.data
              this.token = res.data.token
              this.isLoggedIn = true
            }
            resolve(res)
          })
          .catch((err) => reject(err))
      })
    },
    //退出登录
    logOut() {
      return new Promise((resolve, reject) => {
        ajaxAuthService
          .logOut()
          .then((res) => {
            if (res.code === 1) {
              this.token = ''
            }
            resolve(res)
          })
          .catch((err) => reject(err))
      })
    },
    getAddressCityOSSUrl() {
      return new Promise((resolve, reject) => {
        commonService.getAreaAddressList().then((res) => {
          if (this.addressVersion) {
            if (this.addressVersion !== res.data.version) {
            this.setAddressCityList(res)              
          }
          } else {
            this.setAddressCityList(res)              
          }
          
          resolve(res)  
        })
        .catch((err) => reject(err))
      })
    },
    setAddressCityList(res:any) { 
      return new Promise((resolve, reject) => {
        commonService.getAddressJson(res.data?.ossUrl).then((result) => {
          this.addressVersion = res.data.version
        if (Array.isArray(result) && result.length > 0) {
          let str = JSON.stringify(result);
          let reg1 = new RegExp('key', 'g');
          let reg2 = new RegExp('title', 'g');
          let newStr = str.replace(reg1, 'code').replace(reg2, 'name');
          const dataSource = JSON.parse(newStr)
          this.cityList = dataSource
          this.twoLevelCityList = dataSource.map(v =>  ({...v, children: v.children.map(o => ({...o, children: []}))}))
          }
       
          resolve(res)
        })
        .catch((err) => reject(err))
      })
    },
    /** 存储订单信息 */
    setOrderInfo(value: any) {
      this.orderInfo = value
    },
    /** 存储快速打印订单信息 */
    setQuickPrintOrderInfo(value: any) {
      this.quickPrintOrderInfo = value
    },
    /** 存储城市列表 */
    setCityList(value: any) {
      this.cityList = value
    },
    /** 存储二级城市列表 */
    setTwoLevelCityList(value: any) {
      this.twoLevelCityList = value
    }
  },
  persist: {
    storage: localStorage
  }
})
